function checkFieldValue(e) {
    const field = e.currentTarget || e;
    const fieldWrap = field.closest('.form__field-wrap');

    if (fieldWrap) {
        field.value ? fieldWrap.classList.add('js-has-value') : fieldWrap.classList.remove('js-has-value');
    }
}

export function watchFormFields(selector = '[data-action*="form-watch-fields"]') {
    const form = document.body.querySelectorAll(selector);

    if (form) {
        for (let f = 0; f < form.length; f++) {
            const fields = form[f].querySelectorAll('input, select, textarea');

            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];

                checkFieldValue(field);

                if (field.type === 'select-one' || field.type === 'select-multiple') {
                    field.addEventListener('change', checkFieldValue);
                } else {
                    field.addEventListener('keyup', checkFieldValue);
                }
            }
        }
    }
}

function getForm(form) {
    const formId = form.getAttribute('data-form'),
        culture = document.documentElement.lang;

    let url = '/umbraco/surface/AC/GetACForm';
    let params = `?culture=${culture}`;

    if (formId) {
        params += `&formId=${formId}`;
    }

    url += `${params}`;

    const xhttp = new XMLHttpRequest();
    xhttp.open('GET', url, true);
    xhttp.setRequestHeader('Content-Type', 'application/json');
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4) {
            if (this.status == 200) {
                const response = this.responseText;
                form.insertAdjacentHTML('beforeend', response);
                const formElement = form.querySelector('form');
                if (formElement) {
                    formElement.addEventListener('submit', submitForm);
                    watchFormFields();
                }
            } else {
                const response = `Error: ${this.status} - ${this.statusText}`;
                form.insertAdjacentHTML('beforeend', response);
            }
            form.classList.remove('form--initialization');
        }
    };

    xhttp.send();
}

function toggleFormLoading(form, isLoading) {
    form.classList.toggle('form--loading', isLoading);
}

function getStoredFormObj(form) {
    return {
        actionData: form.querySelector('[name="actiondata"]')?.value,
        thanks: form.querySelector('[name="thanks"]')?.value,
        submit: form.querySelector('[name="submit"]')?.value,
        submitDataUrl: form.querySelector('[name="submitdata-url"]')?.value,
        name: form.querySelector('[name="name"]')?.value,
        errorMessage: form.querySelector('[name="error-message"]')?.value
    };
}

function getFormEmail(form) {
    return form.querySelector('[name="email"]')?.value;
}

function getFormErrors(form) {
    return form.querySelector('.form__errors');
}

function addFormError(form, message) {
    const formErrors = getFormErrors(form);
    const storedFormObj = getStoredFormObj(form);

    if (!formErrors) {
        return;
    }

    const li = document.createElement('li');
    li.classList.add('form__errors-item');
    li.innerHTML = message ?? storedFormObj.errorMessage;
    formErrors.appendChild(li);
}

function mappedContactObj(form) {
    const formElements = form.querySelectorAll('input, textarea, select');

    const contactObj = {
        fieldValues: []
    };

    if (formElements) {
        formElements.forEach(el => {

            if (el.parentNode.classList.contains('form__data')) {
                return;
            }

            if (el.classList.contains('custom-field')) {

                if (el.type && el.type === 'radio') {

                    if (el.checked) {
                        contactObj.fieldValues.push({ field: el.name, value: el.value });
                    }

                } else if (el.type && el.type === 'checkbox') {

                    if (el.checked && !contactObj.fieldValues.some(e => e.field === el.name)) {
                        const possibleSiblings = form.querySelectorAll(`[name="${el.name}"]:checked`);
                        const selectedCheckboxes = Array.from(possibleSiblings).map(({ value }) => value);
                        const values = selectedCheckboxes.join('||');
                        contactObj.fieldValues.push({ field: el.name, value: `||${values}||` });
                    }

                } else if (el.tagName === 'SELECT' && el.hasAttribute('multiple')) {

                    if (el.selectedIndex !== -1) {
                        const selectedOptions = Array.from(el.selectedOptions).map(({ value }) => value);
                        const values = selectedOptions.join('||');
                        contactObj.fieldValues.push({ field: el.name, value: `||${values}||` });
                    }

                } else {

                    if (el.value) {
                        contactObj.fieldValues.push({ field: el.name, value: el.value });
                    }
                }

            } else {

                if (!el.value) {
                    return;
                }

                if (el.name === 'fullname') {
                    const fullName = el.value;
                    let firstName = fullName;
                    let lastName = '';

                    if (fullName.indexOf(' ') >= 0) {
                        firstName = fullName.substr(0,fullName.indexOf(' '));
                        lastName = fullName.substr(fullName.indexOf(' ') + 1);
                    }

                    contactObj['firstname'] = firstName;
                    contactObj['lastname'] = lastName;

                } else {

                    contactObj[el.name] = el.value;
                }
            }
        });
    }

    return contactObj;
}

function submitForm(e) {
    e.preventDefault();

    const form = this.closest('[data-form]');
    const formErrors = getFormErrors(form);
    const contactObj = mappedContactObj(form);
    const storedFormObj = getStoredFormObj(form);

    const data = JSON.stringify({
        contact: contactObj,
        actiondata: JSON.parse(storedFormObj.actionData)
    });

    toggleFormLoading(form, true);

    if (formErrors) {
        formErrors.innerHTML = '';
    }

    if (!window.grecaptcha) {
        console.error('[reCAPTCHA error] API not loaded correctly');
        addFormError(form);
        toggleFormLoading(form, false);
        return;
    }

    grecaptcha.ready(function () {
        try {
            grecaptcha.execute('6LdqtVYsAAAAAKD5-CcKTb5Yh0G9nCzcDLRnfTss', { action: 'submit' })
                .then(function (token) {
                    fetch('https://recaptchaenterprise.googleapis.com/v1/projects/dynamic-reef-485509-f1/assessments?key=AIzaSyDi67b9KqIV_7C4qyBJoGN6vQQVd75GqBs', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ event: { token, expectedAction: 'submit', siteKey: '6LdqtVYsAAAAAKD5-CcKTb5Yh0G9nCzcDLRnfTss' } })
                    })
                        .then(res => res.json())
                        .then(result => {
                            const score = result?.riskAnalysis?.score;
                            if (score && score >= 0.9) {
                                sendFormData(data, form);
                            } else {
                                console.error('[reCAPTCHA error] Form submit rejected due to low score');
                                addFormError(form);
                                toggleFormLoading(form, false);
                            }
                        })
                        .catch(() => {
                            console.error('[reCAPTCHA error] API verification failed');
                            addFormError(form);
                            toggleFormLoading(form, false);
                        });
                })
                .catch(err => {
                    console.error('[reCAPTCHA error]', err);
                    addFormError(form);
                    toggleFormLoading(form, false);
                });
        } catch (err) {
            console.error('[reCAPTCHA error]', err);
            addFormError(form);
            toggleFormLoading(form, false);
        }
    });
}

function sendFormData(data, form) {
    const storedFormObj = getStoredFormObj(form);
    const formEmail = getFormEmail(form);

    const xhttp = new XMLHttpRequest();
    xhttp.open('POST', '/umbraco/surface/AC/AddACContact', true);
    xhttp.setRequestHeader('Content-Type', 'application/json');
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4) {
            window.dataLayer = window.dataLayer || [];

            if (this.status == 200) {
                const response = this.responseText;
                const jsonResponse = response ? JSON.parse(response) : response;

                if (!jsonResponse.errors) {

                    /* Tracking */
                    window.dataLayer.push({
                        'event': 'Form Submission',
                        'formName': storedFormObj.name,
                        'email': formEmail,
                        'status': 'success'
                    });

                    if (storedFormObj.submit === 'open-url' && storedFormObj.submitDataUrl) {
                        window.location.href = storedFormObj.submitDataUrl;
                    } else {
                        form.innerHTML = `<p class="form__text">${storedFormObj.thanks}</p>`;
                    }

                } else {
                    jsonResponse.errors.forEach(error => {
                        console.error('[Form error]', error.title);
                        addFormError(form);
                    });
                }

            } else {
                const response = `Error: ${this.status} - ${this.statusText}`;
                console.error('[Form error]', response);
                addFormError(form);
            }

            toggleFormLoading(form, false);
        }
    };

    xhttp.send(data);
}

export function setupForms(selector = '[data-form]') {
    const forms = document.body.querySelectorAll(selector);

    if (forms) {
        forms.forEach(form => {
            getForm(form);
        });
    }
}
